import MuiTooltip, { TooltipProps } from "@mui/material/Tooltip";

const Tooltip: React.FC<TooltipProps> = MuiTooltip;

export default Tooltip;
export type { TooltipProps };
